module.exports = __webpack_public_path__ + "img/vertical_7_7_3.96ad9fd9.png";